;(function (Wishlist, $) {

    var $wishlistButton = $('.btn-wishlist');
    var $wishlistTile = $('.wishlist-tile-container');
    var numProductTiles = $wishlistTile.length;
    var wishlist = localStorage.getItem('user_wishlist') || [];
    if (wishlist.length > 0) {
      wishlist = JSON.parse(localStorage.getItem('user_wishlist'));
      console.log(wishlist);
    }
    if(wishlist.length == 0){
      $(".wishlist_count").hide()
      // $(".wishlist_mysvg .icon").css("background-color","#000")
    }else{
      $(".wishlist_count").show()
      $(".wishlist_count").html(wishlist.length)
      // $(".wishlist_mysvg .icon").css("background-color","#6f7157")
    }
    /*
     * Update button to show current state (gold for active)
     */   
    var animateWishlist = function (self) {
      $(self).toggleClass('is-active');
    };
  
    /*
     * Add/Remove selected item to the user's wishlist array in localStorage
     * Wishlist button class 'is-active' determines whether or not to add or remove
     * If 'is-active', remove the item, otherwise add it
     */   
    var updateWishlist = function (self) {
      var productHandle = $(self).attr('data-product-handle');
      console.log(productHandle);
      var isRemove = $(self).hasClass('is-active');
      console.log( $(self));
      /* Remove */
      if (isRemove) {
        $(self).find(".ti-heart").html("Add to Wishlist");
        var removeIndex = wishlist.indexOf(productHandle);
        wishlist.splice(removeIndex, 1);
        localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
        console.log(wishlist);
      }
      /* Add */ 
      else {
        $(self).find(".ti-heart").html("Added");
        wishlist.push(productHandle);
        localStorage.setItem('user_wishlist', JSON.stringify(wishlist));    
      }
      if(wishlist.length == 0){
        $(".wishlist_count").hide()
        // $(".wishlist_mysvg .icon").css("background-color","#000")
      }else{
        $(".wishlist_count").show()
        $(".wishlist_count").html(wishlist.length)
        // $(".wishlist_mysvg .icon").css("background-color","#6f7157")
      }
      console.log(JSON.stringify(wishlist));
    };
  
    /*
     * Loop through wishlist buttons and activate any items that are already in user's wishlist
     * Activate by adding class 'is-active'
     * Run on initialization
     */   
    var activateItemsInWishlist = function () {
      $wishlistButton.each(function () {
        var productHandle = $(this).attr('data-product-handle');
        if (wishlist.indexOf(productHandle) > -1) {
          console.log($(this).find(".ti-heart").html("Added"))
          $(this).addClass('is-active');
        }
      });
    };
  
    /*
     * Loop through product titles and remove any that aren't a part of the wishlist
     * Decrement numProductTiles on removal
     */   
    var displayOnlyWishlistItems = function () {
      $wishlistTile.each(function () {
        var productHandle = $(this).attr('data-product-handle');
        if (wishlist.indexOf(productHandle) === -1) {
          $(this).remove();
          numProductTiles--;
        }
      });
    };
  
    /*
     * Check if on the wishlist page and hide any items that aren't a part of the wishlist
     * If no wishlist items exist, show the empty wishlist notice
     */   
    var loadWishlist = function () {
      if (window.location.href.indexOf('pages/wishlist') > -1) {
        displayOnlyWishlistItems();
        $('.wishlist-loader').fadeOut(2000, function () {
          $('.wishlist-grid').addClass('is_visible');
          $('.wishlist-hero').addClass('is_visible');
          if (numProductTiles == 0) {
            $('.wishlist-grid--empty-list').addClass('is_visible');
          } else {
            $('.wishlist-grid--empty-list').hide();
          }
        });
      }
    };
  
    var bindUIActions = function () {
      $wishlistButton.click(function (e) {
        e.preventDefault();
        updateWishlist(this);
        animateWishlist(this);
      });
    };
  
    Wishlist.init = function () {
      bindUIActions();
      activateItemsInWishlist();
      loadWishlist();
    };
  
  }(window.Wishlist = window.Wishlist || {}, jQuery, undefined));
  